import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { toggleModal } from '../../actions/modalActions';
import { addLogoToDevice, getDevices, setCurrentDevice } from '../../actions/deviceActions';

import Modal from './Modal';

class AddLogoModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            imageError: '',
            logos: [],
            device: null,
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.deviceId && (this.props.deviceId !== prevProps.deviceId) ) {
            const { devices, deviceId } = this.props;

            const device = devices.filter(item => item.id === deviceId)[0];
            const firstLogo = device.first_logo
                ? { name: 'firstLogo', content: "", url: device.first_logo.url }
                : null;
            const secondLogo = device.second_logo
                ? { name: 'secondLogo', content: "", url: device.second_logo.url }
                : null;
            const logos = [firstLogo, secondLogo].filter(item => item !== null);

            this.setState({
                device,
                logos,
            });
        }
    }

    toDataURL = url => fetch(url, { mode: 'no-cors' })
        .then(response => response.blob())
        .then(blob => new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result)
        reader.onerror = reject
        reader.readAsDataURL(blob)
    }))
      
    onClose = () => {
        this.setState({
            imageError: '',
            logos: [],
        });
        this.props.toggleModal('logoModal');
        this.props.setCurrentDevice(null);
    }

    onImageChange = (e) => {
        const data = e.target.files[0];

        if (!data) {
            return;
        }

        const [fileType] = data.type.split('/');

        if ((!data || !data.image) && fileType !== 'image') {
            return this.setState({
                imageError: 'dashboard.modals.logo.upload.error'
            });
        }

        if (fileType !== 'image' && data.image) {
            return this.setState({
                imageError: 'dashboard.modals.logo.upload.error'
            });
        }

        const reader = new FileReader();
        reader.readAsDataURL(data);
        reader.onload = () => {
            this.setState({
                imageError: '',
                logos: [...this.state.logos, { name: data.name, content: reader.result }],
            }, () => this.input.value = '');
        };
    }

    removeLogo(name) {
        const logos = this.state.logos.filter(item => item.name !== name);
        this.setState({ logos });
    }

    renderItems() {
        const { logos } = this.state;

        if (logos.length === 0) {
            return;
        }
        return (
            <ul className="simple-list">
                {logos.map(item => {
                    return (
                        <li className="my-4" key={item.name}>
                            <div className="d-flex justify-content-between align-content-center">
                                <img src={item.content || item.url} className="image-preview" alt="logo" />
                                <i className="fa fa-trash action-icon" onClick={() => this.removeLogo(item.name)}></i>
                            </div>
                        </li>
                    );
                })}
            </ul>
        );
    }

    getEncoded(data) {
        if (!data) {
            return null;
        }

        return data.replace(/^data:(.*;base64,)?/, '');
    }

    getSubmitData() {
        const { logos } = this.state;

        return new Promise((resolve) => {
            if (logos.length === 0) {
                resolve ({ first_logo: null, second_logo: null});
            }

            if (logos.length === 1) {
                const firstLogoBase64 = logos[0].content ? logos[0].content : this.toDataURL(logos[0].url);

                Promise.all([firstLogoBase64]).then((base64) => {
                    resolve ({ first_logo: { base64: this.getEncoded(base64[0]) }, second_logo: null });
                });
            }

            if (logos.length === 2) {
                const firstLogoBase64 = logos[0].content ? logos[0].content : this.toDataURL(logos[0].url);
                const secondLogoBase64 = logos[1].content ? logos[1].content : this.toDataURL(logos[1].url);

                Promise.all([firstLogoBase64, secondLogoBase64]).then((base64) => {
                    resolve ({ first_logo: { base64: this.getEncoded(base64[0]) }, second_logo: { base64: this.getEncoded(base64[1]) } });
                });
            }
        })
    }

    onSubmit = () => {
        this.getSubmitData().then((data) => {
            this.props.addLogoToDevice(this.props.deviceId, data)
                .then(() => {
                    this.onClose();
                    this.props.getDevices();
                });
        });
    }

    render() {
        const { imageError, device } = this.state;

        if (!device) {
            return null;
        }

        const { modals, deviceId  } = this.props;
        const show = modals.includes('logoModal');
        const logosCount = this.state.logos.length;
        const noLogos = !device.first_logo && !device.second_logo;
        const disableInput = logosCount >= 2;
        const disableSubmit = logosCount === 0 && noLogos;

        return (
            <Modal
                show={show}
                title={<FormattedMessage id="dashboard.modals.logo.title"/>}
                onClose={this.onClose}
                submitCaption={<FormattedMessage id="dashboard.modals.logo.upload.submit" />}
                onSubmit={this.onSubmit}
                submitDisabled={disableSubmit}
            >
                {
                    imageError &&
                    <div className="invalid-feedback d-block mb-4"><FormattedMessage id={imageError} /></div>
                }
                <div className='d-flex justify-content-between mt-3 mb-2'>
                    <p><FormattedMessage id="dashboard.modals.logo.upload.text"/></p>
                    <div>
                        <label className="custom-file">
                            <input
                                ref={node => this.input = node}
                                type="file"
                                id={deviceId}
                                className="custom-file-input"
                                onChange={(e) => this.onImageChange(e)}
                                disabled={disableInput}
                            />
                            <span className="custom-file-control">
                                <FormattedMessage id="dashboard.buttons.device.add.logo"/>
                            </span>
                        </label>
                    </div>
                </div>
                <hr />
                <p>Logo {logosCount}/2</p>
                {this.renderItems()}
            </Modal>
        );
    }
}

export default connect(
    (state) => ({
        devices: state.device.data.list,
        deviceId: state.device.current,
        modals: state.modals,
    }),
    ({ toggleModal, addLogoToDevice, getDevices, setCurrentDevice })
)(AddLogoModal);



// WEBPACK FOOTER //
// ./src/components/Modal/AddLogoModal.js